import React,{useState} from "react";

import Iframe from 'react-iframe'


const OcrHome = () => {
  // const [iframe, setIframe] = useState('<iframe src="https://ird.gov.np/" width="540" height="450"></iframe>')
  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        OCR Home Page
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>
      {/* iframe */}
      <div className="">
        {/* <iframe src="https://ocr.gov.np/" width={540} height={450}></iframe> */}
        {/* <div dangerouslySetInnerHTML={ iframe} /> */}
        <Iframe url="https://ocr.gov.np/"
        
        height="500px"
        id=""
        className="w-full"
        display="block"
        position="relative"/>

      </div>
    </div>
  );
};

export default OcrHome;
